export function location(value?: string): string | undefined {
    if (!value) return '';

    return value.split('##').shift();
}
